import { SelectProps } from 'antd';
import { VFC } from 'react';
import { useMeterModels } from 'hooks/meter_models/useMeterModels';
import { Manufacturer } from '@enmon/commons/lib/tools';
import { FormattedMessage } from 'react-intl';
import { Commodity } from '@enmon/commons/lib/shared';
import { Nullable } from '@enmon/commons';
import { Select } from './Select';
import { SelectMessages as messages } from './messages';

interface ManufacturerSelectProps extends SelectProps {
  commodity: Nullable<Commodity>;
  value?: Manufacturer['id'];
  onChange?: (value: Manufacturer['id'] | null) => void;
}

export const ManufacturerSelect: VFC<ManufacturerSelectProps> = ({ disabled = false, commodity, ...restProps }) => {
  const { isLoading: isMeterModelsLoading, manufacturersOptions } = useMeterModels(commodity);

  return (
    <Select
      allowClear
      showSearch
      className="w-100"
      disabled={disabled || isMeterModelsLoading}
      filterOption={(input, option) =>
        (option?.label?.toString() ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      loading={isMeterModelsLoading}
      options={manufacturersOptions}
      placeholder={<FormattedMessage {...messages.manufacturerPlaceholder} />}
      {...restProps}
    />
  );
};
